<template>
	<div class="page-content">
		<div class="banner blue" v-if="status == 1">
			<img src="../../assets/images/icon-pay-sw.png" alt="">
			<span>已完成</span>
		</div>
		<div class="banner pink" v-if="status == 2">
			<img src="../../assets/images/icon-pay-overdue.png" alt="">
			<span>订单已过期</span>
		</div>
		<div class="container">
			<div class="order-detail">
				<!-- 班型 -->
				<div class="order-group" v-if="orderType == 1 || orderType == 2">
					<div class="st-name">
						<div class="name">
							<img src="../../assets/images/icon_car.png" alt="">
							<span>{{orderInfo.goods_info.store_name}}</span>
						</div>
						<div class="order-number">订单编号：{{orderInfo.order_info.order_sn}}</div>
					</div>
					<div class="class-type">
						<div class="top">
							<span>{{orderInfo.goods_info.goods_name}}</span>
							<div class="group" v-if="orderType == 2">拼团</div>
						</div>
						<div class="mid">
							<div class="tag">{{orderInfo.goods_info.car_2distribution}}</div>
							<div class="tag">{{orderInfo.goods_info.car_take}}</div>
							<div class="tag">拿本时长{{orderInfo.goods_info.time_long}}天</div>
						</div>
						<div class="bot" v-if="orderType == 2">
							<span class="old-price"><em class="money">￥{{orderInfo.goods_info.goods_price}}</em>元</span>
							<span class="group-price">{{orderInfo.goods_info.need}}人团：￥{{orderInfo.goods_info.prices}}元</span>
						</div>
						<!-- <div class="bot" v-if="orderType == 2">60天拿本 班车接送 周末训练</div> -->
						<div class="order-money">
							实付：<span>￥{{parseFloat(orderInfo.order_info.total_amount).toFixed(2)}}元</span>
						</div>
					</div>
				</div>
				<!-- 优惠券 -->
				<div class="order-coupon" v-if="orderType == 3">
					<div class="st-name">
						<div class="name">
							<img src="../../assets/images/icon_car.png" alt="">
							<span v-if="orderInfo.coupon_car.type == 1">驾校优惠券</span>
							<span v-else>平台优惠券</span>
						</div>
						<div class="order-number">订单编号：{{orderInfo.order_info.order_sn}}</div>
					</div>
					<div class="class-type">
						<div class="top">
							<span>{{orderInfo.coupon_car.name}}</span>
							<div class="vouchers">券</div>
							<div class="price">￥{{parseFloat(orderInfo.coupon_car.price).toFixed(2) || '0.00'}}元</div>
						</div>
						<div class="mid">
							<div class="tag">{{orderInfo.coupon_car.short_name}}</div>
						</div>
						<div class="order-money">
							实付<span>￥{{parseFloat(orderInfo.order_info.total_amount).toFixed(2)}}元</span>
						</div>
					</div>
				</div>
				<!-- 礼物 -->
				<div class="order-gift" v-if="orderType == 4">
					<div class="order-number">
						<img src="../../assets/images/icon_bd.png" alt="">
						<span>订单编号：{{orderInfo.order_info.order_sn}}</span>
					</div>
					<div class="gift-name">
						<div class="img-box">
							<img :src="orderInfo.gift.img" alt="" class="gift-img">
						</div>
						<div class="info">
							<div class="top">
								<span>{{orderInfo.gift.name}}(打赏{{orderInfo.gift.nickname}})</span>
								<span class="price">￥{{orderInfo.gift.price}}<em>元</em></span>
							</div>
							<div class="bot">x{{orderInfo.gift.num}}</div>
						</div>
					</div>
					<div class="order-money">
						<div class="line"></div>
						<div class="price">实付：<span>￥{{parseFloat(orderInfo.gift.pay_money).toFixed(2)}}元</span></div>
					</div>
				</div>
			</div>
			<div class="grouping" v-if="orderType == 2 && status == 1">
				<span v-if="">拼团成功</span>
				<div class="heads">
					<div v-for="(heads,heads_key) in orderInfo.teamHead" :key="heads_key">
						<img :src="heads" alt="">
					</div>
				</div>
				<img src="../../assets/images/icon_right.png" alt="" class="right-icon">
			</div>
			<div class="order-info">
				<div class="group-info">
					<p>订单编号：{{orderInfo.order_info.order_sn}}<img src="../../assets/images/icon_add.png" alt="" @click="copy(orderInfo.order_info.order_sn)"></p>
					<p>下单时间：{{orderInfo.order_info.add_time_str}}</p>
					<!--<p v-if="orderType != 4">权益有效期：{{orderInfo.vrorders.vr_indate_str}}</p>-->
					<template v-if="status == 1">
						<!--已完成订单/礼物无核销-->
						<p v-if="orderType != 4">核销时间：{{orderInfo.vrorders.vr_usetime|formatItmer}}</p>
					</template>
					<p>购买人：{{orderInfo.userinfo.nickname}}</p>
					<p>手机号：{{orderInfo.userinfo.mobile}}</p>
					<template v-if="orderInfo.store_info && orderInfo.store_info.region && orderInfo.store_info.region !== 'undefined'">
						<p v-if="orderType != 4">提供城市：{{orderInfo.store_info.region[1]}}</p>
						<p v-if="orderType != 4">提供门店：{{orderInfo.store_info.full_name}}</p>
						<p v-if="orderType != 4">门店地址：{{orderInfo.store_info.region_text}}{{orderInfo.store_info.store_address}}</p>
					</template>
					<p v-if="orderType == 3 && orderInfo.coupon_car">权益说明：<div v-html="orderInfo && orderInfo.coupon_car && orderInfo.coupon_car.rule || ''"></div></p>
				</div>
			</div>
			<div class="footer">如对订单有疑问，请拨打：<a href="tel://">{{conf.card_phone}}</a></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ODCompleted',
	components: {},
	data() {
		return {
			orderInfo:{
				goods_info:{},
				order_info:{},
				userinfo:{},
				coupon_car:{},
				gift:{},
				vrorders:{},
				store_info:{},
			},
			status:1,
			orderType: 1, //订单类型
			conf: {}
		}
	},
	created() {
		var id = this.$route.query.id;

		//订单信息获取
		this.$ajax.get('m/trade/order_info?id='+id,{}).then(res=>{

			// if(!res.refund_goods){
			// 	this.$toast.text('该订单无退款信息~',{
			// 		duration:3000,
			// 		onClose:this.$router.push({path:'/MyOrder'})
			// 	});
			// }
			this.orderInfo = res;
			//支付状态 0=》未支付[过期]
			this.status = parseInt(res.order_info.pay_status) == 0 ? 2 : 1;
			switch (parseInt(res.order_prom_type)) {
				case 1219:	//报名学车
					this.orderType = 1;break;
				case 1221:	//拼团学车
					this.orderType = 2;break;
				case 1223:  //优惠卷
					this.orderType = 3;break;
				case 1225:	//礼物
					this.orderType = 4;break;
				default:
					this.$toast.text('订单类型错误~');
					setTimeout(()=>{
						this.$router.push({name:'MyOrder'})
					},2000)
			}
		})
		this.getConf()
	},
	methods: {
		getConf() {
			this.$ajax.get('m/system/conf').then(res => {
				this.conf = res;
			})
		},
		copy(sn){
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.setAttribute('value', sn)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$toast.text('复制成功');
			}
			document.body.removeChild(input)
		},
	},
	filters: {
		formatItmer: function (value) {
			value = value+'000';
			let date = new Date(parseInt(value));
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = date.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = date.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		}
	},
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		.banner {
			width: 100%;
			height: 132px;
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			padding-top: 20px;
			align-items: center;
			span {
				font-size: 17px;
				color: #fff;
				margin-top: 10px;
			}
		}
		.banner.blue {
			background:linear-gradient(270deg,rgba(0,194,255,1) 0%,rgba(60,67,236,1) 100%);
		}
		.banner.pink {
			background:linear-gradient(270deg,rgba(255,120,136,1) 0%,rgba(255,84,140,1) 100%);
		}
		.container {
			width: 92%;
			margin: -20px auto 54px;
			.order-detail {
				width: 100%;
				background-color: #fff;
				border-radius: 3px;
				box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
				.order-group {
					width: 100%;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
							.status {
								flex: 1;
								text-align: right;
								color: #EB273B;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 10px 0;
						border-top: 1px #E2E2E2 solid;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							span {
								font-size: 15px;
								color: #333;
							}
							.group {
								width: 32px;
								height: 20px;
								background-color: #FF808E;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
						.bot {
							width: 100%;
							margin-top: 10px;
							display: flex;
							align-items: center;
							.old-price {
								font-size: 14px;
								color: #999;
								margin-right: 10px;
								.money {
									font-style: normal;
									text-decoration: line-through;
									margin-right: 3px;
								}
							}
							.group-price {
								font-size: 14px;
								color: #EB273B;
							}
						}
						.order-money {
							width: 100%;
							box-sizing: border-box;
							padding: 10px 0;
							display: flex;
							align-items: center;
							justify-content: flex-end;
							border-top: 1px #E2E2E2 solid;
							font-size: 14px;
							margin-top: 10px;
							span {
								color: #EB273B;
							}
						}
					}
				}
				.order-single {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							color: #333;
							span {
								font-size: 15px;
							}
							.price {
								font-size: 14px;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
						.bot {
							width: 100%;
							margin-top: 10px;
							font-size: 14px;
							color: #666;
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 0;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						border-top: 1px #E2E2E2 solid;
						font-size: 14px;
						margin-top: 10px;
						span {
							color: #EB273B;
						}
					}
				}
				.order-coupon {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.st-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						.name {
							display: flex;
							align-items: center;
							span {
								margin-left: 5px;
								font-size: 15px;
								color: #333;
							}
						}
						.order-number {
							box-sizing: border-box;
							padding-left: 19px;
							font-size: 14px;
							color: #999;
							margin-top: 5px;
						}
					}
					.class-type {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 10px 0;
						.top {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							span {
								font-size: 15px;
								color: #333;
							}
							.vouchers {
								width: 32px;
								height: 20px;
								background-color: #6FCBF3;
								border-radius: 3px;
								line-height: 20px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin-left: 5px;
							}
							.price {
								font-size: 15px;
								color: #EB273B;
								flex: 1;
								text-align: right;
							}
						}
						.mid {
							width: 100%;
							display: flex;
							flex-wrap: wrap;
							margin-top: 10px;
							.tag {
								height: 20px;
								line-height: 20px;
								background-color: #F8F8F8;
								border-radius: 3px;
								font-size: 12px;
								color: #666;
								margin-right: 5px;
								box-sizing: border-box;
								padding: 0 5px;
							}
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 10px 0;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						border-top: 1px #E2E2E2 solid;
						font-size: 14px;
						margin-top: 10px;
						span {
							color: #EB273B;
						}
					}
				}
				.order-gift {
					width: 100%;
					height: 100%;
					box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
					border-radius: 3px;
					.order-number {
						width: 100%;
						height: 42px;
						box-sizing: border-box;
						padding: 10px;
						border-bottom: 1px #E2E2E2 solid;
						display: flex;
						align-items: center;
						font-size: 14px;
						color: #999;
						img {
							margin-right: 5px;
						}
					}
					.gift-name {
						width: 100%;
						box-sizing: border-box;
						padding: 10px;
						display: flex;
						.img-box {
							width: 60px;
							height: 60px;
							box-sizing: border-box;
							padding: 8px 5px;
							border-radius: 3px;
							border: 1px #E2E2E2 solid;
							margin-right: 10px;
							.gift-img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.info {
							width: 60%;
							flex: 1;
							.top {
								width: 100%;
								display: flex;
								align-items: center;
								justify-content: space-between;
								font-size: 15px;
								color: #333;
								.price {
									em {
										font-style: normal;
										font-size: 12px;
									}
								}
							}
							.bot {
								width: 100%;
								margin-top: 5px;
								display: flex;
								justify-content: flex-end;
								font-size: 12px;
								color: #999;
							}
						}
					}
					.order-money {
						width: 100%;
						box-sizing: border-box;
						padding: 0 10px 10px;
						.line {
							width: 100%;
							height: 1px;
							background-color: #E2E2E2;
						}
						.price {
							font-size: 14px;
							color: #666;
							margin-top: 10px;
							text-align: right;
							span {
								color: #EB273B;
							}
						}
					}
				}
			}
			.grouping {
				width: 100%;
				height: 40px;
				border-radius: 3px;
				box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
				margin-top: 15px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				padding: 0 10px;
				span {
					flex: 1;
					font-size: 14px;
					color: #333;
				}
				.heads {
					display: flex;
					img {
						width: 30px;
						height: 30px;
						margin-left: -8px;
						border-radius: 50%;
						object-fit: cover;
					}
				}
				.right-icon {
					margin-left: 5px;
				}
			}
			.order-info {
				width: 100%;
				background-color: #fff;
				border-radius: 3px;
				box-shadow: 0px 0px 12px rgba(0,0,0,0.08);
				margin-top: 15px;
				.group-info {
					width: 100%;
					box-sizing: border-box;
					padding: 10px;
					line-height: 20px;
					font-size: 13px;
					color: #666;
					img {
						margin-left: 5px;
					}
				}
			}
		}
		.footer {
			width: 100%;
			height: 50px;
			position: fixed;
			bottom: 0;
			left: 0;
			line-height: 54px;
			text-align: center;
			font-size: 12px;
			color: #999;
			background-color: #fff;
			a {
				color: #3C43EC;
				text-decoration: underline;
			}
		}
	}

	/deep/ .nut-radio.nut-radio-size-base input {
		width: 16px;
		height: 16px;
	}
	/deep/ .nut-radio input:checked {
		background-color: #3C43EC;
		border-color: #3C43EC;
	}
</style>
